// domains.
import { formatDate } from '@domains/orchestrator-pricing-committee/utils/dates';

export const InfoTracker = ({
  stepName,
  date,
  isCompleted,
  isInProgress,
  isRejected,
  colorStatus,
  stepData,
}: {
  stepName: string;
  date?: string;
  isCompleted: boolean;
  isInProgress: boolean;
  isRejected: boolean;
  colorStatus: string;
  stepData: unknown;
}) => {
  return (
    <div>
      <div
        style={{
          fontWeight: 'bold',
          color: colorStatus,
        }}
      >
        {stepName}
      </div>
      {isCompleted && (
        <div style={{ fontSize: '0.9rem', color: '#6c757d' }}>
          {formatDate(date)}
        </div>
      )}
      {isInProgress && (
        <div style={{ fontSize: '0.9rem', color: 'orange' }}>En progreso</div>
      )}
      {isRejected && (
        <div style={{ fontSize: '0.9rem', color: 'red' }}>Fue rechazado</div>
      )}
      {!stepData && (
        <div style={{ fontSize: '0.8rem', color: '#adb5bd' }}>No iniciado</div>
      )}
    </div>
  );
};
